import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatPaginator, MatPaginatorIntl } from "@angular/material/paginator";
import { MatDialog, DialogPosition } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiCallService } from "src/app/core/services/api-call-service";
import { SnackbarCollection } from "src/app/core/services/snackbar.service";
import { SubscriptionPlanHandlerService } from "src/app/core/services/subscription-plan-handler.service";
import { WidgetConfigService } from "src/app/core/services/widget-config.service";
import { ConfirmationDialogBoxComponent, ContactUsDialogComponent, DefaultExcluysionDialogBoxComponent, NotDeletedListDialogBoxComponent, OfferSummaryDialogComponent } from "src/app/shared/components/dialog-box";
import { OfferFilterOverlayComponent } from "../../component"; 
import { TokenStorageService } from "src/app/core/auth/token-storage.service";
import { TranslateDynamicText } from "src/app/shared/pipes/dynamic-translation.pipe";
import { getdateformatService } from "src/app/core/services/get-date-format.service";

@Component({
  selector: 'app-gift-code-listing',
  templateUrl: './gift-code-listing.component.html',
  styleUrls: ['./gift-code-listing.component.css']
})
export class GiftCodeListingComponent implements OnInit {

  @ViewChild("paginator") paginator: MatPaginator;
    offerList = [];
    filter = {
      label: "",
    };
    rightMargin;
    page = 1;
    size = 10;
    status = [];
    channel = [];
    statusDraft: boolean = false;
    statusSent: boolean = false;
    statusScheduled: boolean = false;
    sortBy = ["DATE"];
    order = ["DESC"];
    totalOfferCount;
    loading = false;
    sortByTagText = "Date";
    timeout;
    sub: Subscription;
    appSubscriptionPlan;
    validWidgets;
    mobileView;
    mobileMedia = window.matchMedia("(max-width: 896px)");
    segementMap = {};
    searchedValue = undefined;
    numberOfCustomers;
    qid = this.tokenStorage.getqId();
    productCategoryType = null;
  
    constructor(
      private apiCall: ApiCallService,
      private snackbar: SnackbarCollection,
      private dialog: MatDialog,
      public router: Router,
      private _WidgetConfigService: WidgetConfigService,
      private snackBar: SnackbarCollection,
      private _SubscriptionPlanHandlerService: SubscriptionPlanHandlerService,
      private tokenStorage: TokenStorageService,
      private _i18nDynamicTranslate: TranslateDynamicText,
      private date_format: getdateformatService,
      private _MatPaginatorIntl: MatPaginatorIntl
    ) {
      window["screen-name"] = "CHOOSE OFFER";
    }
  
    @HostListener("scroll", ["$event"])
    onScroll(event: any) {
      if (this.mobileView)
        if (
          event.target.offsetHeight + event.target.scrollTop >=
          event.target.scrollHeight - 1
        ) {
          this.page += 1;
          this.getOfferList(
            this.page,
            this.size,
            this.status,
            this.channel,
            this.sortBy,
            this.order,
            this.filter.label
          );
        }
    }
  
    ngOnInit() {
      if (this.mobileMedia.matches) {
        this.mobileView = true;
      } else {
        this.mobileView = false;
      }
      this.getOfferList(
        this.page,
        this.size,
        this.status,
        this.channel,
        this.sortBy,
        this.order
      );
      this.getWidgets();
    }
  
    async getWidgets() {
      this.validWidgets = await this._WidgetConfigService.getWidget();
      this.appSubscriptionPlan =
        await this._WidgetConfigService.getAppSubscriptionPlan();
    }
  
    ngOnDestroy() {
      this.sub.unsubscribe();
    }
  
    getOfferList(page, size, status, channel, sortby, order, offerName?) {
      this.loading = true;
      if (!this.mobileView) {
        this.offerList = [];
      }
      if (offerName !== "") {
        if (offerName !== this.searchedValue) {
          this.offerList = [];
          this.searchedValue = offerName;
        }
      }
      if (this.sub) {
        this.sub.unsubscribe();
      }
      this.sub = this.apiCall
        .getAllGiftCodeListWithPagination(
          page,
          size,
          status,
          channel,
          sortby,
          order,
          offerName
        )
        .subscribe(
          (response) => {
            this.loading = false;
            if (response["message"] == "success") {
              let body = (response["body"]);
              if (body.length != 0) {
                this.totalOfferCount = JSON.parse(body["totalCount"]);
                if (this.mobileView) {
                  body["giftcodes"].forEach((element) => {
                    this.numberOfCustomers = 0;
                    if (element["segments"] !== null) {
                      this.apiCall
                        .getCustomerCountSegmentList(element["segments"])
                        .subscribe((response) => {
                          this.numberOfCustomers = JSON.parse(response["body"])[
                            "totalCustomerCount"
                          ];
                          element["customerCount"] = this.numberOfCustomers;
                        });
                    } else if (
                      element["isSegmented"] == false &&
                      element["status"] != "Draft"
                    ) {
                      let isCustomer = (element['isSegmented'] == false && element['status'] != 'Draft' && element['allCustomer']) || (element['isSegmented'] == false && element['status'] != 'Draft' && !element['allCustomer'] && !element['allLead']) ? true : false;
                      let isLead = element['status'] != 'Draft' && element['allLead'] ? true : false;
                      this.apiCall
                        .getAnalytics(new Date(), new Date(), isLead, isCustomer)
                        .subscribe((response) => {
                          this.numberOfCustomers = JSON.parse(
                            response["body"]
                          ).numberOfCustomers;
                          element["customerCount"] = this.numberOfCustomers;
                        });
                    } else {
                      element["customerCount"] = this.numberOfCustomers;
                    }
                    this.offerList.push(element);
                  });
                } else {
                  this.offerList = body["giftcodes"];
                }
                let sheader = document.getElementById("tableHeads");
                let interval = setInterval(() => {
                  let sideMenu = document.getElementById("side-menu-offer");
                  let sideMenuParent = document.getElementById(
                    "side-menu-offer-parent"
                  );
                  if (sideMenu && sheader) {
                    clearInterval(interval);
                    if (
                      sideMenuParent.clientHeight < sideMenuParent.scrollHeight
                    ) {
                      this.rightMargin = "14px"; //5 is the scroller width
                      sheader.style.paddingRight = this.rightMargin;
                    } else {
                      sheader.style.paddingRight = "0px";
                    }
                  }
                });
              } else {
                this.totalOfferCount = 0;
              }
            }
          },
          (err) => {
            this.snackBar.openSnackBar(this._i18nDynamicTranslate.transform("Error in fetching giftcode details", ['POS_PAGE']), 2000);
            this.loading = false;
          }
        );
    }
  
    async createOffer() {
      if (
        await this._SubscriptionPlanHandlerService.IsValidOperation(
          this.appSubscriptionPlan
        )
      ) {
        this.router.navigate(["app/offer/create-giftcode"]);
      }
    }
  
    getNextData(pageEvent) {this.page = pageEvent.pageIndex + 1;
      this.size = pageEvent.pageSize;
      this.getOfferList(
        this.page,
        this.size,
        this.status,
        this.channel,
        this.sortBy,
        this.order,
        this.filter.label
      );
    }
  
    statusChange(event) {
      this.status = ["DRAFT", "SENT", "SCHEDULED"];
      this.status = [];
      if (this.statusDraft) {
        this.status.push("DRAFT");
      }
      if (this.statusSent) {
        this.status.push("SENT");
      }
      if (this.statusScheduled) {
        this.status.push("SCHEDULED");
      }
  
      this.executeListing();
    }
  
    channelSelect(value) {
      this.channel = value;
      this.getOfferList(
        this.page,
        this.size,
        this.status,
        this.channel,
        this.sortBy,
        this.order,
        this.filter.label
      );
    }
  
    sortByChanges() {
      this.getOfferList(
        this.page,
        this.size,
        this.status,
        this.channel,
        this.sortBy,
        this.order,
        this.filter.label
      );
    }
  
    async cloneOffer(idnumber, adminCreated, qid) {
      if (
        await this._SubscriptionPlanHandlerService.IsValidOperation(
          this.appSubscriptionPlan
        )
      ) {
        this.router.navigate([
          "app/offer/create-offer",
          { id: idnumber, clone: "true", admin: adminCreated, qid: qid },
        ]);
      }
    }
  
    onKeySearch(event: any) {
      clearTimeout(this.timeout);
      var $this = this;
        this.timeout = setTimeout(function () {
          if(event.data!==' ')
          $this.executeListing();
        }, 600);
      }
  
    executeListing() {
      this.paginator.pageIndex = 0;
      this.page = 1;
      this.getOfferList(
        this.page,
        this.size,
        this.status,
        this.channel,
        this.sortBy,
        this.order,
        this.filter.label.trim()
      );
    }
  
    async previewOffer(idnumber) {
      if (
        await this._SubscriptionPlanHandlerService.IsValidOperation(
          this.appSubscriptionPlan
        )
      ) {
        this.router.navigate([
          "app/offer/preview-giftcode",
          { id: idnumber, preview: true },
        ]);
      }
    }
  
    previewOrEditOffer(offerid) {
          this.previewOffer(offerid);
    }
  
    reOrder() {
      if (this.order[0] == "ASC") {
        this.order = ["DESC"];
        this.sortByChanges();
      } else {
        this.order = ["ASC"];
        this.sortByChanges();
      }
    }

    openFilterDialog(): void {
      const dialogPosition: DialogPosition = {
        top: "0px",
        right: "0px",
      };
      const dialogRef = this.dialog.open(OfferFilterOverlayComponent, {
        width: "230px",
        height: "100%",
        position: dialogPosition,
        panelClass: "custom-dialog-container",
        data: {
          status: this.status,
          channel: this.channel,
        },
      });
      dialogRef.afterClosed().subscribe((response) => {
        if (response) {
          this.status = response.status;
          this.channel = response.channel;
          this.executeListing();
        }
      });
    }

    getDateFormat(type?){
      return this.date_format.getDateFormat(type);
    }

    getTooltipOffer(channel){
      var tooltip = "";
      tooltip = "Channel: " + channel
      return tooltip;
    }

    checkChannel(type, list){
      let channelList = JSON.parse(list); 
      if (channelList) {
        const lowercaseChannelList = Object.fromEntries(
            Object.entries(channelList).map(([key, value]) => [key.toLowerCase(), value])
        );
        return type.toLowerCase() in lowercaseChannelList;
    }
    return false;
    }
  


}
